(function () {
  function hasIntentionalLock() {
    if (document.body.classList.contains('open-mobile-sidebar')) return true;
    if (document.body.classList.contains('menu_open')) return true;
    if (document.body.classList.contains('cart-sidebar-show')) return true;
    if (document.body.classList.contains('auth-sidebar-show')) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;

    if (document.body.classList.contains('overflow-hidden-mobile')) {
      return !!document.querySelector('menu-drawer details[open], header-drawer details[open], .menu-opening');
    }

    if (document.body.classList.contains('lang-currency-sidebar-show')) return true;
    if (document.body.classList.contains('show-pickup-availability')) return true;
    if (document.body.classList.contains('quickshop-popup-show')) return true;
    if (document.body.classList.contains('video-show')) return true;
    if (document.body.classList.contains('fancybox-active')) return true;
    if (document.body.classList.contains('open_search_mobile')) return true;
    if (document.body.classList.contains('term-condition-show')) return true;
    if (document.body.classList.contains('notify-me-show')) return true;
    if (document.body.classList.contains('show_popup_notification')) return true;

    if (document.body.classList.contains('toolbar-modal-open')) {
      return !!document.querySelector('.toolbar [data-toggle][data-mobile="mobile"][aria-expanded="true"]');
    }

    if (document.body.classList.contains('has-halo-loader')) {
      return document.querySelector('.loading-overlay--custom:not(.hidden)') !== null;
    }

    return false;
  }

  function clearStuckLockClasses() {
    if (document.body.classList.contains('toolbar-modal-open')) {
      const openToggle = document.querySelector('.toolbar [data-toggle][data-mobile="mobile"][aria-expanded="true"]');
      if (!openToggle) document.body.classList.remove('toolbar-modal-open');
    }

    if (document.body.classList.contains('has-halo-loader')) {
      const loader = document.querySelector('.loading-overlay--custom:not(.hidden)');
      if (!loader) document.body.classList.remove('has-halo-loader');
    }

    if (document.body.classList.contains('overflow-hidden-mobile')) {
      const openDrawer = document.querySelector('menu-drawer details[open], header-drawer details[open], .menu-opening');
      if (!openDrawer) document.body.classList.remove('overflow-hidden-mobile');
    }

    if (document.body.classList.contains('open-mobile-sidebar')) {
      const sidebar = document.querySelector('.page-sidebar');
      if (!sidebar || window.getComputedStyle(sidebar).visibility === 'hidden') {
        document.body.classList.remove('open-mobile-sidebar');
      }
    }
  }

  function unlockScroll() {
    if (!document.body) return;

    clearStuckLockClasses();

    if (hasIntentionalLock()) return;

    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.overflowY = '';
    document.documentElement.style.height = '';
  }

  function init() {
    if (!document.body) {
      window.requestAnimationFrame(init);
      return;
    }

    unlockScroll();

    document.addEventListener(
      'wheel',
      (event) => {
        const target = event.target;
        if (target && target.tagName === 'INPUT' && target.type === 'range') {
          target.blur();
        }
      },
      { passive: true }
    );

    window.addEventListener('scroll', unlockScroll, { passive: true });
    document.addEventListener('click', unlockScroll, { passive: true });

    const observer = new MutationObserver(unlockScroll);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    window.setTimeout(unlockScroll, 0);
    window.setTimeout(unlockScroll, 500);
    window.setTimeout(unlockScroll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', unlockScroll);
})();
